import React from 'react';
import PropTypes from 'prop-types';

import { kebabCase, snakeCase } from 'lodash';
import displayName from 'component-lib/displayName';
import { datesConfig, formatDate } from '../../utilities/dates/dates';

import styles from './MetadataTable.scss';

const { LONG_WITH_TIME_FIRST } = datesConfig;
const formattedDate = date => formatDate(date, LONG_WITH_TIME_FIRST);

const FORMATTED_FIELDS = {
    createdAt: formattedDate,
    updatedAt: formattedDate,
};

export default function MetadataTable({
    item,
    getMessage,
    fields,
    baseKey,
    extraClassName,
}) {
    const messageKey = which => `${baseKey}.${snakeCase(which)}`;
    return (
        <table className={`${styles['metadata-table']} ${extraClassName}`}>
            <thead>
                <tr>
                    {
                        fields.map(field => (<th key={field}>
                            {getMessage(messageKey(field))}
                        </th>),)
                    }
                </tr>
            </thead>
            <tbody>
                <tr>
                    {fields.map(field => (
                        <td key={field} data-field={kebabCase(field)}>
                            {FORMATTED_FIELDS[field] ? FORMATTED_FIELDS[field](item[field]) : item[field]}
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
    );
}

MetadataTable.displayName = displayName('Footers/MetadataTable');

MetadataTable.propTypes = {
    baseKey: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    fields: PropTypes.array.isRequired,
    getMessage: PropTypes.func.isRequired,
    extraClassName: PropTypes.string,
};

MetadataTable.defaultProps = {
    extraClassName: '',
};
